import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api.js";
import { Card, PageHeader, Spinner } from "../components/ui.js";
import { ChartCard } from "../components/ChartCard.js";
import { Sugestoes } from "../components/Sugestoes.js";
import { SugestoesIA } from "../components/SugestoesIA.js";

const PANELS = [
  { key: "frete", label: "Frete & Faturamento" },
  { key: "pareto", label: "Concentração (Pareto)" },
  { key: "frete_zero", label: "Completude do frete" },
  { key: "operacao", label: "Operação" },
  { key: "frota", label: "Frota" },
  { key: "tendencias", label: "Tendências" },
  { key: "compliance", label: "Compliance" },
  { key: "qualidade", label: "Qualidade de dados" },
];

export function Insights() {
  const [panel, setPanel] = useState("frete");
  const data = useQuery({
    queryKey: ["insight", panel],
    queryFn: async () => (await api.get(`/insights/${panel}`)).data as Record<string, unknown>[],
  });
  const rows = data.data ?? [];
  const cols = rows[0] ? Object.keys(rows[0]) : [];

  return (
    <div>
      <PageHeader title="Insights & Análise" subtitle="Dashboards e gráficos com detecção de singularidades e customização por usuário" />

      <div className="mb-6 space-y-4">
        <Sugestoes />
        <SugestoesIA />
      </div>

      <div className="mb-4 flex flex-wrap gap-2" data-testid="panel-tabs">
        {PANELS.map((p) => (
          <button key={p.key} data-testid={`panel-${p.key}`}
            className={`rounded-lg px-3 py-1.5 text-sm font-medium ${panel === p.key ? "bg-brand-600 text-white" : "bg-white text-slate-600 hover:bg-slate-100"}`}
            onClick={() => setPanel(p.key)}>
            {p.label}
          </button>
        ))}
      </div>

      {data.isLoading ? (
        <Spinner />
      ) : rows.length === 0 ? (
        <Card><p className="text-sm text-slate-400">Sem dados para este painel.</p></Card>
      ) : (
        <ChartCard chartKey={`insights:${panel}`} rows={rows} columns={cols} height={340} />
      )}
    </div>
  );
}
